var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M256 256v170.663H0V256h256z",
  fill: "#0052b4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M512 85.337V256H256V85.337h256z",
  fill: "#d80027"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M128 123.034l11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M384 293.697l11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
})));

export default SvgPa;